import { GET_CANCELCHARGES, GET_CANCELTRIP } from "resources/actionTypes";


export function cancelTrip(payloadData, tripPayload, pageType) {

  const data = {
    trip: payloadData,
    tripPayload: tripPayload,
    pageType: pageType
    }

  return {
    type: GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED,
    payload: data
  };
}

export function getCancelCharges(id, setCancelCharges) {

  const payloadData = {
    id: id,
    setCancelCharges: setCancelCharges
  }
  return {
    type: GET_CANCELCHARGES.GET_CANCELCHARGES_REQUESTED,
    payload: payloadData
  };
}